/// <reference path="../typings/index.d.ts" />
/// <reference path="TermometroJustGage.d.ts" />

namespace App {
  export class TermometroJustGage implements ITermometroJustGage {
    public valueFontColor = '#000000';
    public labelFontColor = '#000000';
    public inicializarCampo(seletorId: string, valorInicial: string | number, label: string = "Compras", min: number = 1, max: number = 10, functionTextRenderer: any = function (val: any) { if (val < 5) { return 'Baixo'; } else if (val <= 8) { return 'Médio'; } else { return 'Alto'; } },
      customSectors: any = { percents: false, ranges: [{ color: "#00e673", lo: 0, hi: 4 }, { color: "#ffff00", lo: 5, hi: 8 }, { color: "#ff1a1a", lo: 9, hi: 10 }] }): any {
      var gauge: any = new JustGage({
        id: seletorId, // the id of the html element
        value: valorInicial,
        min: min,
        max: max,
        label: label,
        width: 100,
        height: 50,
        gaugeWidthScale: 0.6,
        valueMinFontSize: 12,
        valueFontColor: this.valueFontColor,
        labelFontColor: this.labelFontColor,
        textRenderer: functionTextRenderer,
        customSectors: customSectors
      });

      return gauge;
    }
  }
}
